import { KENV, CloudCastConfig } from './types/admin'
import * as data from './env.default.json'

const settings = {} as Map<KENV, CloudCastConfig>
settings[KENV.Dev] = data.firebase.dev
settings[KENV.Stage] = data.firebase.stage
settings[KENV.Prod] = data.firebase.prod
settings[KENV.Prodeu] = data.firebase.prodeu

export default settings[KENV.Prodeu]
